export function convertToCssKey(input) {
  var parts = input.split('.').filter(function (p) {
    return p !== 'default';
  }).map(function (p, i) {
    return i < 1 || i > 2 ? p[0] : p;
  });
  return '--n' + [parts.slice(0, 3).join('-'), parts.slice(3).join('')].filter(Boolean).join('-');
}
export function generateCSSVars(partialTheme) {
  var cssVars = {};
  function recurse(obj, prefix) {
    Object.keys(obj).forEach(function (key) {
      var value = obj[key];
      var newKey = prefix ? [prefix, key].join('.') : key;
      if (typeof value === 'undefined') return;
      if (typeof value === 'string') return cssVars[convertToCssKey(newKey)] = value;
      recurse(value, newKey);
    });
  }
  recurse(partialTheme);
  return cssVars;
}
export function generateRootStyles(theme, isTallText) {
  var classes = '';
  var cssVars = generateCSSVars(theme);
  var cssVarsString = Object.keys(cssVars).map(function (key) {
    return "".concat(key, ":").concat(cssVars[key]);
  }).join(';');
  var sizes = theme.typography.size;
  Object.keys(sizes).forEach(function (sizeName) {
    var size = sizes[sizeName];
    var typeFace = isTallText ? 'tall' : 'latin';
    var lineHeights = size[typeFace];
    Object.keys(lineHeights).forEach(function (textOrParagraph) {
      var value = lineHeights[textOrParagraph];
      var className = ['.nt', sizeName];
      var shortCode = textOrParagraph === 'default' ? '' : 'p';
      if (shortCode) className.push(shortCode);
      classes += "".concat(className.join('-'), "{font-size:var(--nt-size-").concat(sizeName, ",").concat(size.default, ");line-height:var(--nt-size-").concat(sizeName, "-").concat(typeFace[0]).concat(shortCode, ",").concat(value, ")}");
    });
  });
  var fonts = theme.typography.font;
  Object.keys(fonts).forEach(function (fontWeight) {
    var font = fonts[fontWeight];
    classes += ".nt-".concat(fontWeight, "{font-family:var(--nt-font-").concat(fontWeight, "-f,").concat(font.face, ");font-weight:var(--nt-font-").concat(fontWeight, "-w,").concat(font.weight, ")}");
  });
  return [cssVars, ":root{".concat(cssVarsString, "}").concat(classes)];
}